import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { CategoryDto, CoordinatesDto, DuplicateRaceRequest, EventAdminDetailDto, EventAdminSummaryDto, EventSummaryDto, Mission, PointAdminSummaryDto, PointSummaryDto, RaceAdminSummaryDto, RaceDetailDto, RankingDto, RunnerSummaryDto, TeamDto } from '@aoe/client';
import * as _ from 'lodash-es';
import { Subscription, tap } from 'rxjs';
import { CreateAccountDialogComponent } from 'src/app/shared/component/dialog/create-account-dialog/create-account-dialog.component';
import { DuplicateRaceComponent } from 'src/app/shared/component/dialog/duplicate-race/duplicate-race.component';
import { InitEventDialogComponent } from 'src/app/shared/component/dialog/init-event-dialog/init-event-dialog.component';
import { InitRaceDialogComponent } from 'src/app/shared/component/dialog/init-race-dialog/init-race-dialog.component';
import { ConfirmationDialogComponent } from '../../shared/component/dialog/confirmation-dialog/confirmation-dialog.component';
import { DialogVideoComponent } from '../../shared/component/dialog/dialog-video/dialog-video.component';
import { EditCategoryDIalogComponent } from '../../shared/component/dialog/edit-category-dialog/edit-category-dialog.component';
import { EditTeamDialogComponent } from '../../shared/component/dialog/edit-team-dialog/edit-team-dialog.component';
import { EventMapComponent } from '../../shared/component/dialog/event-map/event-map.component';
import { InfoDialogComponent } from '../../shared/component/dialog/info-dialog/info-dialog.component';
import { InformationsPrestaComponent } from '../../shared/component/dialog/informations-presta/informations-presta.component';
import { LoginComponent } from '../../shared/component/dialog/login/login.component';
import { MapSelectorComponent } from '../../shared/component/dialog/map-selector/map-selector.component';
import { MissionComponent } from '../../shared/component/dialog/mission/mission.component';
import { PointAdminDialogComponent } from '../../shared/component/dialog/point-admin-dialog/point-admin-dialog.component';
import { RunnerAdminComponent } from '../../shared/component/dialog/runner-admin/runner-admin.component';
import { RunnerModalComponent } from '../../shared/component/dialog/runner-modal/runner-modal.component';
import { SelectOrganisationComponent } from '../../shared/component/dialog/select-organisation/select-organisation.component';
import { StartRaceComponent } from '../../shared/component/dialog/start-race/start-race.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  private dialogRunner!: MatDialogRef<RunnerModalComponent>;
  private dialogRunnerAdmin!: MatDialogRef<RunnerAdminComponent>;
  private dialogLogin!: MatDialogRef<LoginComponent>;
  private dialogEventMap!: MatDialogRef<EventMapComponent>;
  private dialogPointAdmin!: MatDialogRef<PointAdminDialogComponent>;
  private dialogEditCategory!: MatDialogRef<EditCategoryDIalogComponent>;
  private dialogConfirmation!: MatDialogRef<ConfirmationDialogComponent>;
  private dialogPrestaInfo!: MatDialogRef<InformationsPrestaComponent>;
  private dialogVideo!: MatDialogRef<DialogVideoComponent>;
  private dialogEditTeam!: MatDialogRef<EditTeamDialogComponent>;
  private dialogMapSelector!: MatDialogRef<MapSelectorComponent>;
  private dialogStartRace!: MatDialogRef<StartRaceComponent>;
  private dialogVolunteerMission?: MatDialogRef<MissionComponent>;
  private dialogInfo?: MatDialogRef<InfoDialogComponent>;
  private dialogSelectOrgansiation?: MatDialogRef<SelectOrganisationComponent>;
  private dialogCreateAccount?: MatDialogRef<CreateAccountDialogComponent>
  private dialogInitEvent?: MatDialogRef<InitEventDialogComponent>;
  private dialogInitRace?: MatDialogRef<InitRaceDialogComponent>;
  private dialogDuplicateRace?: MatDialogRef<DuplicateRaceComponent>

  private readonly subsDialogEditCategory = new Subscription();


  private readonly dialogConfig: MatDialogConfig = {
    width: '100%',
    maxWidth: '800px',
    maxHeight: 'calc(90vh - 100px)',
    position: {
      top: '100px'
    }
  }

  constructor(private readonly dialog: MatDialog) { }

  openRunnerModal(r: RankingDto, points: Array<PointSummaryDto>, race: RaceDetailDto): void {
    this.dialogRunner = this.dialog.open(RunnerModalComponent, { ...this.dialogConfig, data: { runner: r, points, race } });
  }

  closeRunnerModal() {
    this.dialogRunner.close();
  }

  openRunnerAdminModal(runner: RunnerSummaryDto | null): void {
    this.dialogRunnerAdmin = this.dialog.open(RunnerAdminComponent, { ...this.dialogConfig, data: { runner } });
  }

  closeRunnerAdminModal() {
    this.dialogRunnerAdmin.close();
  }

  openEventMap(incommingEvents: EventSummaryDto[]): void {
    this.dialogEventMap = this.dialog.open(EventMapComponent, { ...this.dialogConfig, data: incommingEvents });
  }

  closeEventMap() {
    this.dialogEventMap.close();
  }

  openPrestaInfo(): void {
    this.dialogPrestaInfo = this.dialog.open(InformationsPrestaComponent, {
      height: '95vh'
    });
  }

  closePrestaInfo() {
    this.dialogPrestaInfo.close();
  }

  openLoginModal(): void {
    this.dialogLogin = this.dialog.open(LoginComponent);
  }

  closeLoginModal() {
    this.dialogLogin.close();
  }

  openPointAdminModal(point: PointAdminSummaryDto | null, eventId: string): void {
    this.dialogPointAdmin = this.dialog.open(PointAdminDialogComponent, { ...this.dialogConfig, data: { point, eventId } });
  }

  closePointAdminModal() {
    this.dialogPointAdmin.close();
  }

  openEditCategoryModal(cat: CategoryDto | null, eventId: string, callback: (result: any) => any): void {
    this.dialogEditCategory = this.dialog.open(EditCategoryDIalogComponent, { ...this.dialogConfig, data: { category: cat, eventId: eventId } });
    this.dialogEditCategory.afterClosed().subscribe(callback)
  }

  closeEditCategoryModal() {
    this.dialogEditCategory.close();
    this.subsDialogEditCategory.unsubscribe();
  }

  openConfirmationModal(template: string, { raceId, category }: { raceId?: string, category?: CategoryDto, mission?: Mission.MissionDto }) {
    this.dialogConfirmation = this.dialog.open(ConfirmationDialogComponent, { data: { template, raceId, category } })
    return this.dialogConfirmation;
  }

  closeConfirmationModal() {
    this.dialogConfirmation.close();
  }

  openVideoModal(videoId: string): void {
    this.dialogVideo = this.dialog.open(DialogVideoComponent, { data: { videoId }, maxWidth: '80%', minWidth: '80%', height: 'auto' });
  }

  closeVideoModal() {
    this.dialogVideo.close();
  }

  openEditTeamModal(team?: TeamDto): void {
    this.dialogEditTeam = this.dialog.open(EditTeamDialogComponent, { data: { team } });
  }

  closeEditTeamModal() {
    this.dialogEditTeam.close();
  }

  openMapSelectorModal(coordinates?: CoordinatesDto | null, callback?: (result: any) => void): void {
    this.dialogMapSelector = this.dialog.open(MapSelectorComponent, { data: { coordinates }, panelClass: 'map-selector-dialog' });
    this.dialogMapSelector.afterClosed().subscribe({ next: callback })
  }

  closeMapSelectorModal() {
    this.dialogMapSelector.close();
  }

  openStartRaceModal(race: RaceAdminSummaryDto, eventId: string, callback?: (result: any) => void): void {
    this.dialogStartRace = this.dialog.open(StartRaceComponent, { data: { race, eventId }, minWidth: '350px' });
    this.dialogStartRace.afterClosed().subscribe({ next: callback })
  }

  closeStartRaceModal() {
    this.dialogStartRace.close();
  }

  openVolunteerMissionModal(mission?: Mission.MissionDto, event?: EventAdminDetailDto, callback?: (result: any) => void): void {
    if (_.isNil(this.dialogVolunteerMission)) {
      this.dialogVolunteerMission = this.dialog.open(MissionComponent, { data: { mission, event } });
    }
    this.dialogVolunteerMission?.afterClosed().pipe(tap(() => this.dialogVolunteerMission = undefined)).subscribe({ next: callback })
  }

  closeVolunteerMissionModal() {
    if (!_.isNil(this.dialogVolunteerMission))
      this.dialogVolunteerMission?.close();
  }

  openInfoModal(info: string, content: string, callback?: (result: any) => void): void {
    this.dialogInfo = this.dialog.open(InfoDialogComponent, { data: { info, content } });
    this.dialogInfo.afterClosed().pipe(tap(() => this.dialogInfo = undefined)).subscribe({ next: callback })
  }

  closeInfoModal() {
    if (!_.isNil(this.dialogInfo))
      this.dialogInfo?.close();
  }

  openSelectOrganisationModal(callback?: (result: string | null) => void): void {
    this.dialogSelectOrgansiation = this.dialog.open(SelectOrganisationComponent);
    this.dialogSelectOrgansiation.afterClosed().pipe(tap(() => this.dialogSelectOrgansiation = undefined)).subscribe({ next: callback })
  }

  closeSelectOrganisation() {
    if (!_.isNil(this.dialogSelectOrgansiation))
      this.dialogSelectOrgansiation?.close();
  }

  openCreateAccountModal(callback?: (result: string | null) => void): void {
    if (!this.dialogCreateAccount)
      this.dialogCreateAccount = this.dialog.open(CreateAccountDialogComponent);
    this.dialogCreateAccount.afterClosed().pipe(tap(() => this.dialogCreateAccount = undefined)).subscribe({ next: callback })
  }

  closeCreateAccountModal() {
    if (!_.isNil(this.dialogCreateAccount))
      this.dialogCreateAccount?.close();
  }

  openInitEventModal(callback?: (result: EventAdminSummaryDto | null) => void): void {
    if (!this.dialogInitEvent)
      this.dialogInitEvent = this.dialog.open(InitEventDialogComponent);
    this.dialogInitEvent.afterClosed().pipe(tap(() => this.dialogInitEvent = undefined)).subscribe({ next: callback })
  }

  closeInitEventModal(e: EventAdminDetailDto | null) {
    if (!_.isNil(this.dialogInitEvent))
      this.dialogInitEvent?.close(e);
  }

  openInitRaceModal(eventId: string, callback?: (result: RaceAdminSummaryDto | null) => void): void {
    if (!this.dialogInitRace)
      this.dialogInitRace = this.dialog.open(
        InitRaceDialogComponent,
        {
          data: { eventId },
          minWidth: '350px'
        });
    this.dialogInitRace.afterClosed().pipe(tap(() => this.dialogInitRace = undefined)).subscribe({ next: callback })
  }

  closeInitRaceModal(e: RaceAdminSummaryDto | null) {
    if (!_.isNil(this.dialogInitRace))
      this.dialogInitRace?.close(e);
  }

  openDuplicateRace(race: RaceAdminSummaryDto, callback: (data: DuplicateRaceRequest) => void) {
    if (!this.dialogDuplicateRace)
      this.dialogDuplicateRace = this.dialog.open(DuplicateRaceComponent, { data: { race } });

    this.dialogDuplicateRace.afterClosed().subscribe(callback)
  }

  closeDuplicateRace(data: DuplicateRaceRequest) {
    if (!_.isNil(this.dialogDuplicateRace))
      this.dialogDuplicateRace?.close(data);
  }
}
